import { render, staticRenderFns } from "./manage-attr.vue?vue&type=template&id=3e09de32&scoped=true&"
import script from "./manage-attr.vue?vue&type=script&lang=js&"
export * from "./manage-attr.vue?vue&type=script&lang=js&"
import style0 from "./manage-attr.vue?vue&type=style&index=0&id=3e09de32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e09de32",
  null
  
)

export default component.exports